export enum Language {
  EN = 'en',
  EN_US = 'en-US',
  DE = 'de',
  DE_DE = 'de-DE'
}

export const languages = Object.values(Language);
